jQuery(document).ready(function($) {
    function change_cart(data) {
        var result = {};
        $.ajax({
            url: '/cart/change.js',
            method: 'POST',
            dataType: 'json',
            data: data,
            async: false
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function get_cart() {
        var result = {};
        $.ajax({
            url: '/cart.js',
            dataType: 'json',
            async: false
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function add_cart(id, quantity) {
        var result = {};
        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            dataType: 'json',
            data: {
                id: id,
                quantity: quantity,
            },
            async: false
        }).done(function(response){
            result = response;
        }).fail(function(response){
            result = response;
        }).always(function(response) {
            result = response;
        });
        return result;
    }

    function update_cart_html(items) {
        console.log(items);
        var list = '';
        if (items.items.length > 0){
            $('.bag-amout').html(items.items.length);
        }else{
            $('.bag-amout').html('0');
        }
        if (items.item_count > 0) {
            for (var i in items.items) {
                list += '<div class="shop-item">' +
                    '<a style="background-image: url(' + items.items[i].image + ');" class="image-link" href="' + items.items[i].url + '">' +
                    '</a> ' +
                    '<div class="line-infor"> ' +
                    '<a href="' + items.items[i].url + '" class="product-title">' + items.items[i].title + '</a> ' +
                    '<span class="amount-money" data-currency-'+shop_currency+'="'+money_format+(items.items[i].price/100)+'">' + items.items[i].quantity + ' x ' + money_format+(items.items[i].price/100)+'</span> ' +
                    '</div> ' +
                    '<a class="remove-product" data-variant-id='+items.items[i].variant_id+' href="/cart/change?line=' + (parseInt(i) + 1) + '&amp;quantity=0" title="Remove this item"> ' +
                    '<i class="fa fa-times"></i> ' +
                    '</a>' +
                    '</div>';//show_price(items.total_price/100)
            }
            $('.total-price').html('<span>Total:</span> <span class="money" data-currency-'+shop_currency+'="'+money_format+(items.total_price/100)+'">'+money_format+(items.total_price/100)+'</span>');
            $('.button-checkout').html('<a href="/cart">view cart</a> <a href="/checkout">checkout</a>');
        }else{
            $('.total-price').empty();
            $('.button-checkout').empty();
            list +="<div class='shop-item no-product'><p>No product in your cart!</p></div>";
        }
        return list;
    }
    function cartModal(items){
        var list = '';
        if(items.item_count > 0){
            for (var i in items.items) {
                list += '<div class="product"> ' +
                    '<div class="img"><img src="'+ items.items[i].image +'" width="80" height="100" alt=""></div> ' +
                '<div class="title"><h4><a href="' + items.items[i].url + '">' + items.items[i].title + '</a></h4></div> ' +
                '<div class="price"><span>' + money_format+(items.items[i].price/100)+'</span></div> ' +
                '<div class="quantity"> ' +
                '<p> ' +
                '<i class="fa minus">-</i><input type="number" id="number" name="updates[]" value="' + items.items[i].quantity + '"> <i class="fa plus">+</i> ' +
                '</p> ' +
                '</div> ' +
                '<div class="line-price"> ' +
                '<p>' + money_format+(items.items[i].line_price/100)+'</p> ' +
                '</div> ' +
                '<div class="remove"> ' +
                '<a class="remove-order" data-variant-id='+items.items[i].variant_id+' href="/cart/change?line=' + (parseInt(i) + 1) + '&amp;quantity=0"><i class="fa fa-trash"></i></a> ' +
                '</div>' +
                '</div>';
            }
            var like = '';
            for(var i = 0; i < 4;i++){
                var num = Math.floor(( Math.random() * (products.length -1) ) + 1);
                var add = products[num].variants.length == 1?
                    '<form action="cart/add" method="post"> ' +
                    '<input type="hidden" name="quantity" value="1"> ' +
                    '<input type="hidden" name="id" value="'+products[num].variants[0].id+'"> ' +
                    '<button  type="submit" class="product-add-to-cart button"> ' +
                    '<span>Add to cart</span> ' +
                    '</button> ' +
                    '</form>':'<a href="/products/'+products[num].handle+'" class="button">select options</a>';
                like += '<div class="col-xs-12 col-sm-6 col-md-3"> ' +
                    '<img src="'+products[num].images[0]+'" width="270" height="344" alt=""> ' +
                '<h4><a href="/products/'+products[num].handle+'">'+products[num].title+'</a></h4> ' +
                '<p class="price">'+money_format+(products[num].price/100)+'</p>'+add+
                '</div>';
                
            }
            $('.may-like .row').html(like);
            $('.cart-popup-container .list-product').html(list);
            $('.cart-popup-container .total-cart span').html(money_format+(items.total_price/100));
            $('.cart-popup-container').addClass('active');
            $('body').addClass('overflow-hidden');
        }
    }

    function update_cart_modal_html(items){
        var list = '';
        if(items.item_count > 0){
            for (var i in items.items) {
                list += '<div class="product"> ' +
                    '<div class="img"><img src="'+ items.items[i].image +'" width="80" height="100" alt=""></div> ' +
                '<div class="title"><h4><a href="' + items.items[i].url + '">' + items.items[i].title + '</a></h4></div> ' +
                '<div class="price"><span>' + money_format+(items.items[i].price/100)+'</span></div> ' +
                '<div class="quantity"> ' +
                '<p> ' +
                '<i class="fa minus">-</i><input type="number" id="number" name="updates[]" value="' + items.items[i].quantity + '"> <i class="fa plus">+</i> ' +
                '</p> ' +
                '</div> ' +
                '<div class="line-price"> ' +
                '<p>' + money_format+(items.items[i].line_price/100)+'</p> ' +
                '</div> ' +
                '<div class="remove"> ' +
                '<a class="remove-order" data-variant-id='+items.items[i].variant_id+' href="/cart/change?line=' + (parseInt(i) + 1) + '&amp;quantity=0"><i class="fa fa-trash"></i></a> ' +
                '</div>' +
                '</div>';
            }
            var like = '';
            for(var i = 0; i < 4;i++){
                var num = Math.floor(( Math.random() * (products.length -1) ) + 1);
                var add = products[num].variants.length == 1?
                    '<form action="cart/add" method="post"> ' +
                    '<input type="hidden" name="quantity" value="1"> ' +
                    '<input type="hidden" name="id" value="'+products[num].variants[0].id+'"> ' +
                    '<button  type="submit" class="product-add-to-cart button"> ' +
                    '<span>Add to cart</span> ' +
                    '</button> ' +
                    '</form>':'<a href="/products/'+products[num].handle+'" class="button">select options</a>';
                like += '<div class="col-xs-12 col-sm-6 col-md-3"> ' +
                    '<img src="'+products[num].images[0]+'" width="270" height="344" alt=""> ' +
                '<h4><a href="/products/'+products[num].handle+'">'+products[num].title+'</a></h4> ' +
                '<p class="price">'+money_format+(products[num].price/100)+'</p>'+add+
                '</div>';
            }
            $('.may-like .row').html(like);
            $('.cart-popup-container .list-product').html(list);
            $('.cart-popup-container .total-cart span').html(money_format+(items.total_price/100));
        }else{
            $('.cart-popup-container').removeClass('active');
            $('body').removeClass('overflow-hidden');
        }
    }

    //Change option variant before add to cart.
    $(document).on("click", '.option-1 .value', function () {
        $('.option-1 .value').removeClass('active');
        $(this).addClass('active');
    });

    $(document).on("click", '.option-2 .value', function () {
        $('.option-2 .value').removeClass('active');
        $(this).addClass('active');
    });

    $(document).on("click", '.option-3 .value', function () {
        $('.option-3 .value').removeClass('active');
        $(this).addClass('active');
    });

    // filter then add variant to add to cart
    $(document).on("click", '.option .value', function () {
        // determine variants active
        var variant_opt1 = $(this).parents('.options').find('.option-1 .value.active').data('value');
        var variant_opt2 = $(this).parents('.options').find('.option-2 .value.active').data('value');
        var variant_opt3 = $(this).parents('.options').find('.option-3 .value.active').data('value');
        var variant_will_add = variant_opt1 + ' / ' + variant_opt2 + ' / ' + variant_opt3;
        // check all variant to compare
        var parent = $(this).parents('.options');
        var show_price = $(this).parents('.infor-options').find('.price-sale');
        var show_cprice = $(this).parents('.infor-options').find('.price-compare');
        var product_id = parent.data('id');
        var variant_class = '.slick-variant-' + product_id;
        $(variant_class).each(function (index) {
            var variant_name = $(this).data('name');
            if (variant_name == variant_will_add) {
                var variant_id = $(this).data('id');
                var variant_price = $(this).data('price');
                var variant_cprice = $(this).data('cprice');
                show_price.html(variant_price);
                show_cprice.html(variant_cprice);
                parent.find('.variant-infor').val(variant_id);
                parent.find('.add-wishlist').attr('data-variant', variant_id);
                // wish list heart
                var variant_id_numb = Number(variant_id);
                if (wishlists_arr.indexOf(variant_id_numb) >= 0) {
                    parent.find('.fa-heart').removeClass('far').addClass('fas');
                }else{
                    parent.find('.fa-heart').removeClass('fas').addClass('far');
                }
            }
        });
    });


    $(document).on('click', '.product-add-to-cart', function(e) {
        e.preventDefault();
        var $this = $(this);
        $this.children('i').addClass('loading');
        var form = $(this).closest('form');
        var variant_id = form.find('input[name="id"]').val();
        var quantity = 1;
        if (form.find('input[name="quantity"]').length > 0) quantity = form.find('input[name="quantity"]').val();
        if (variant_id.length > 0) {
            var item = add_cart(variant_id, quantity);
            if (typeof item.id != typeof undefined) {
                var items = get_cart();
                if (typeof items.token != 'undefined') {
                    var str = update_cart_html(items);
                    setTimeout(function(){
                        $('#modal-quickview').modal('hide');
                        cartModal(items);
                        $this.children('i').removeClass('loading');
                    },1000);
                    $('.quick-cart-container').html(str);
                }
            }else{
                alert(JSON.parse(item.responseText).description);
                $this.children('i').removeClass('loading');
                return;
            }
        }
        setTimeout(function(){
            $('.button-wrap[data-variant = "'+variant_id+'"]').html('<a href="/cart" data-toggle="tooltip" title="View cart" data-placement="top"><i class="fas fa-check"></i></a>');
        }, 1000);
    });
    // remove quick cart
    $(document).on('click', '.remove-product', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var href_array = href.split('?');
        var search = href_array[1];
        var search_arr = search.split("&");
        var variant_id = $(this).data('variant-id');
        var data = {};
        for (var i in search_arr) {
            var item = search_arr[i].split('=');
            data[item[0]] = item[1];
        }
        var items = change_cart(data);
        if (typeof items.token !== 'undefined') {
            var str = update_cart_html(items);
            $('.quick-cart-container').html(str);
            $('.button-wrap[data-variant = "'+variant_id+'"]').html('<button  type="submit" class="product-add-to-cart" data-toggle="tooltip" title="Add to cart" data-placement="top"><i class="fas fa-shopping-cart"></i></button>');
        }
    });

    // remove order modal
    $(document).on('click', '.remove-order', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var href_array = href.split('?');
        var search = href_array[1];
        var search_arr = search.split("&");
        var variant_id = $(this).data('variant-id');
        var data = {};
        for (var i in search_arr) {
            var item = search_arr[i].split('=');
            data[item[0]] = item[1];
        }
        var items = change_cart(data);
        if (typeof items.token !== 'undefined') {
            update_cart_modal_html(items);
            var str = update_cart_html(items);
            $('.quick-cart-container').html(str);
            $('.button-wrap[data-variant = "'+variant_id+'"]').html('<button  type="submit" class="product-add-to-cart" data-toggle="tooltip" title="Add to cart" data-placement="top"><i class="fas fa-shopping-cart"></i></button>');
        }
    });
});